/**
 * T095: useUpdateCategory Hook
 * Mutation hook for updating categories
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateCategory, type UpdateCategoryInput } from '@/services/categories'
import { queryKeys } from '@/lib/query-keys'

interface UpdateCategoryParams {
  id: string
  input: UpdateCategoryInput
}

export function useUpdateCategory() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, input }: UpdateCategoryParams) => updateCategory(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.categories.all })
    },
  })
}
